import React from 'react';
import { useParams } from 'react-router-dom';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { DeliveryOrderViewModel } from 'app/edozvola/cases/delivery-order/model/delivery-order.model';
import { fetchDeliveryOrderViewQuery } from 'app/edozvola/cases/delivery-order/service/delivery-order.queries';

const DeliveryOrderTable = () => {
  const { id: uuid } = useParams<{ id: string }>();

  const renderTableRow = (value: DeliveryOrderViewModel, deliveryOrderIndex: number, totalItems: number) => {
    return (
      <tr key={deliveryOrderIndex}>
        <td>
          <span>{value.name}</span>
        </td>
        <td>
          <span>{value.oib}</span>
        </td>
        <td>
          <span>{value.partyType}</span>
        </td>
        <td>
          <span>{value.address}</span>
        </td>
        <td>
          <span>{value.email}</span>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema osoba kojima se dostavlja završni akt.'}
        initialPaginationColumn={'name'}
        fetchDataQuery={fetchDeliveryOrderViewQuery}
        fetchDataProps={[uuid]}
      >
        <ViewTableHeaderColumn renderSort columnLabels={['Ime i prezime/Naziv']} sortKey={'name'} width={'300px'} />
        <ViewTableHeaderColumn renderSort columnLabels={['OIB']} sortKey={'oib'} width={'100px'}/>
        <ViewTableHeaderColumn renderSort columnLabels={['Vrsta stranke']} sortKey={'partyType'} width={'100px'} />
        <ViewTableHeaderColumn renderSort columnLabels={['Adresa']} sortKey={'address'} width={'150px'} />
        <ViewTableHeaderColumn renderSort columnLabels={['Email']} sortKey={'email'} width={'150px'} />
      </ViewTable>
    </>
  );
};

export default DeliveryOrderTable;
